/**
 * 楽天から移行した商品説明文(body_html)に残っている、楽天商品ページへのリンクを
 * 対応する Shopify の商品ページへ書き換える。
 *
 * 楽天の商品コードは Shopify の handle と一致している:
 *   https://item.rakuten.co.jp/dees-l-balance/agr111036/  ->  /products/agr111036
 *
 * 該当 handle の商品が Shopify に無い(未公開・削除済み)場合は、HEAD の結果を見て
 * 元の楽天リンクへ戻すので 404 にはならない。
 * 商品ページ以外の楽天リンク(contents/ や gold/ のLPなど)は対象外。
 */
(() => {
  const SELECTOR = 'a[href*="item.rakuten.co.jp/"]';
  const ITEM_URL = /^https?:\/\/item\.rakuten\.co\.jp\/[^/]+\/([^/?#]+)\/?/i;
  const HANDLE = /^[a-z0-9][a-z0-9_-]*$/;

  const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
  const checked = new Map();

  /** handle が実在する商品かを1回だけ確認する */
  const exists = (handle) => {
    if (!checked.has(handle)) {
      checked.set(
        handle,
        fetch(`${root}/products/${handle}`, { method: 'HEAD' })
          .then((response) => response.ok)
          // 通信エラー時は差し戻さない(オフライン等で楽天へ戻すのは避ける)
          .catch(() => true)
      );
    }

    return checked.get(handle);
  };

  const rewrite = (link) => {
    if (link.dataset.rakutenRewritten) return;

    const match = link.getAttribute('href')?.match(ITEM_URL);
    if (!match) return;

    const handle = decodeURIComponent(match[1]).trim().toLowerCase();
    if (!HANDLE.test(handle)) return;

    const original = link.href;
    link.dataset.rakutenRewritten = handle;
    link.href = `${root}/products/${handle}`;
    link.removeAttribute('target');

    exists(handle).then((found) => {
      if (found) return;
      link.href = original;
      delete link.dataset.rakutenRewritten;
    });
  };

  const scan = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(SELECTOR)) rewrite(node);
    node.querySelectorAll(SELECTOR).forEach(rewrite);
  };

  scan(document.body);

  // クイックビューやセクション再描画で後から挿入される説明文にも対応する
  new MutationObserver((records) => {
    for (const record of records) record.addedNodes.forEach(scan);
  }).observe(document.body, { childList: true, subtree: true });
})();
